import { All, KeyNumberValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { searchPush, updatePagination } from "../common/actions";
import ResultPagination from "../components/ResultPagination";

export function mapStateToProps({ appState }: All) {
  return {
    limit: (appState as any)[appState.app].pagination.resultLimit,
    pageNumber: (appState as any)[appState.app].pagination.pageNumber,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    handleChangePage: (event: React.ChangeEvent<unknown>, newPage: number) => {
      dispatch(updatePagination("pageNumber", newPage));
      dispatch(searchPush());
    },
    handlePickPage: (value: KeyNumberValue) => {
      dispatch(updatePagination("pageNumber", value.pageNumber));
      dispatch(searchPush());
    },
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updatePagination("resultLimit", parseInt(event.target.value)));
      dispatch(updatePagination("pageNumber", 1));
      dispatch(searchPush());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultPagination);
